<template>
    <div class="fSize">
        <div style="padding:0 0.24rem 0.24rem;background:#fff" >
            <van-field :border="false" left-icon="user-o" label="用户姓名" v-model="detailInfo.userName"
                       input-align="right" disabled class="newBorder" label-width="40%"/>
            <van-field :border="false" left-icon="phone-o" label="用户手机号码" v-model="detailInfo.userPhoneNumber"
                       input-align="right" class="newBorder" disabled label-width="40%"/>
            <van-field :border="false" left-icon="idcard" label="用户证件号码" v-model="detailInfo.userCardNumber"
                       input-align="right" class="newBorder" disabled label-width="40%"/>
            <!-- <van-field :border="false" left-icon="label-o" label="预约类型" readonly v-model="columnsText[detailInfo.type]"
                       @click="isEdit?showPicker = true:showPicker = false" input-align="right" class="newBorder"
                       style="font-size: 0.32rem;" :disabled="!isEdit" :class="isEdit?'edit-cell':''" label-width="40%" /> -->
            <van-field :border="false" left-icon="label-o" label="预约类型" readonly v-model="columnsText[detailInfo.type]"
                       disabled input-align="right" class="newBorder"
                       :class="isEdit?'edit-cell':''" label-width="40%" />
            <van-field required name="radio" :border="false" left-icon="points" label="预约人性别" input-align="right" class="newBorder" 
                       :disabled="!isEdit" :class="isEdit?'edit-cell':''" label-width="40%">
                <template #input>
                    <van-radio-group v-model="userSexTmp" direction="horizontal" :disabled="!isEdit">
                        <van-radio name="1">男</van-radio>
                        <van-radio name="0">女</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <!-- <van-field :border="false" left-icon="contact" label="预约人年龄" 
                       v-model="detailInfo.userAge" input-align="right" class="newBorder" :disabled="!isEdit"
                       :class="isEdit?'edit-cell':''" label-width="40%" type="digit"/>        -->
            <van-field required :border="false" left-icon="phone-o" label="手机号码" v-model="detailInfo.phoneNumber"
                       input-align="right" class="newBorder" :disabled="!isEdit" 
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%" type="tel" />
            <van-field required :border="false" left-icon="contact" label="单位名称" v-model="detailInfo.company"
                       input-align="right" class="newBorder" :disabled="!isEdit" 
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%"/>   
            <van-field required :border="false" left-icon="orders-o" label="单位性质" :value="detailInfo.companyNature"
                       input-align="right" class="newBorder" :disabled="!isEdit" @click="showPicker1 = isEdit"
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%" readonly clickable/>
            <!-- <van-field required :border="false" left-icon="points" label="从业地点" v-model="detailInfo.workPlace"
                       input-align="right" class="newBorder" :disabled="!isEdit" 
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%"/> -->
            <van-field required :border="false" left-icon="points" label="从业地点" :value="detailInfo.workPlace"
                       input-align="right" class="newBorder" :disabled="!isEdit" @click="showPicker6 = isEdit"
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%" readonly clickable/>
            <van-field required :border="false" left-icon="paid" label="文化程度" :value="detailInfo.educationDegree"
                       input-align="right" class="newBorder" :disabled="!isEdit" @click="showPicker2 = isEdit"
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%" readonly clickable/>
            <!-- <van-field :border="false" left-icon="paid" label="民  族" :value="detailInfo.nation"
                       input-align="right" class="newBorder" :disabled="!isEdit" @click="showPicker5 = isEdit"
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%" readonly clickable/> -->

            <van-field required :border="false" left-icon="user-circle-o" label="工  种" :value="detailInfo.workType"
                       input-align="right" class="newBorder" :disabled="!isEdit" @click="showPicker3 = isEdit"
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%" readonly clickable/>

            <van-field required :border="false" left-icon="paid" label="工  龄" :value="detailInfo.workAge"
                       input-align="right" class="newBorder" :disabled="!isEdit" @click="showPicker4 = isEdit"
                       :class="detailInfo.type!=='health_cert'?'display1':isEdit?'edit-cell':''" label-width="40%" readonly clickable/>

            
            <van-field :border="false" left-icon="label-o" label="预约日期" v-model="detailInfo.preDate"
                       input-align="right" class="newBorder" disabled label-width="40%"/>
            <van-field :border="false" left-icon="clock-o" label="预约时段"
                       :value="detailInfo.prePeriod==='morning'?'上午':'下午'"
                       input-align="right" class="newBorder" disabled label-width="40%"/>
            <van-field :border="false" left-icon="friends-o" label="预约人数"
                       v-model="detailInfo.preCount"
                       input-align="right" class="newBorder" disabled label-width="40%"/>
            <!-- <van-field :border="false" left-icon="friends-o" label="预约人数"
                       v-model="detailInfo.preCount" input-align="right" class="newBorder" :disabled="!isEdit"
                       :class="isEdit?'edit-cell':''" label-width="40%"/> -->
            <br/><br/>
        </div>
        <van-cell class="buttonFixed" safe-area-inset-bottom>
            <van-button :text="isEdit?'保 存':'编 辑'" round type="info" @click="editAppointment" style="width:50%"/>
            <van-button text="删 除" type="danger" round @click="deleteAppointment" style="width:50%"/>
        </van-cell>
        <van-popup v-model="showPicker" position="bottom">
            <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"/>
        </van-popup>
        <van-popup v-model="showPicker1" position="bottom">
            <van-picker show-toolbar :columns="columns1" @confirm="onConfirm1" @cancel="showPicker1 = false"/>
        </van-popup>
        <van-popup v-model="showPicker2" position="bottom">
            <van-picker show-toolbar :columns="columns2" @confirm="onConfirm2" @cancel="showPicker2 = false"/>
        </van-popup>
        <van-popup v-model="showPicker3" position="bottom">
            <van-picker show-toolbar :columns="columns3" @confirm="onConfirm3" @cancel="showPicker3 = false"/>
        </van-popup>
        <van-popup v-model="showPicker4" position="bottom">
            <van-picker show-toolbar :columns="columns4" @confirm="onConfirm4" @cancel="showPicker4 = false"/>
        </van-popup>
        <van-popup v-model="showPicker5" position="bottom">
            <van-picker show-toolbar :columns="columns5" @confirm="onConfirm5" @cancel="showPicker5 = false"/>
        </van-popup>
        <van-popup v-model="showPicker6" position="bottom">
            <van-picker show-toolbar :columns="columns6" @confirm="onConfirm6" @cancel="showPicker6 = false"/>
        </van-popup>
    </div>
</template>
<script>
    import {updateAppiontment, delAppiontment, getAppiontmentDetail} from "@/api/common";
    import {Button, Field, Toast, Dialog, Cell, Popup, Picker,RadioGroup, Radio} from "vant";

    export default {
        components: {
            [Button.name]: Button, [Field.name]: Field, [Toast.name]: Toast, [Dialog.name]: Dialog, [Cell.name]: Cell,
            [Popup.name]: Popup, [Picker.name]: Picker,[RadioGroup.name]: RadioGroup,[Radio.name]: Radio,
        },
        data() {
            return {
                // 是否编辑预约
                isEdit: false,
                // 预约详情信息
                detailInfo: {
                    userSex: null,
                },
                userSexTmp: "",
                // 当前预约id
                appointmentId: null,
                columns: [{text: "个人", value: "personal"}, {text: "团检", value: "group"},
                    {text: "从业体检", value: "health_cert"}, {text: "职业病", value: "occup_dis"},
                ],
                columnsText: {"personal": "个人", "group": "团检", "health_cert": "从业体检", "occup_dis": "职业病"},
                columns1: ['全民', '集体', '三资，个体', '国企', '社会组织机构'],
                columns2: ['研究生', '大学本科', '大学专科', '中专', '中技', '高中', '初中', '小学', '半文盲', '文盲'],
                columns3: ['厨师', '美发师', '美容师', '洗碗工', '其他服务人员'],
                columns4: ['<1年', '1年', '2年', '3年', '>=5年'],
                columns5: ['汉族', '蒙古族', '回族', '藏族', '满族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族', '黎族', '傈僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族', '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '朝鲜族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族', '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
                columns6: ['敖勒召其镇', '上海庙镇', '城川镇', '昂素镇'],
                showPicker: false,
                showPicker1: false,
                showPicker2: false,
                showPicker3: false,
                showPicker4: false,
                showPicker5: false,
                showPicker6: false,
            };
        },
        created() {
            const that = this;
            that.appointmentId = that.$route.query.id;
            that.getDetail();
        },
        methods: {
            async getDetail() {
                const that = this;
                
                const {data} = await getAppiontmentDetail({id: that.appointmentId});
                console.log(data);
                that.detailInfo = data;
                debugger
                that.userSexTmp = data.userSex + "";
                console.log("=== " + that.userSexTmp)
                console.log("@@@ " + that.detailInfo)
            },
            async editAppointment() {
                const that = this;
                that.detailInfo.userSex = parseInt(that.userSexTmp);
                console.log("@@@ " + that.detailInfo.userSex)
                if (!that.isEdit) {
                    that.isEdit = true;
                } else {
                    Dialog.confirm({
                        message: "确认保存预约信息吗？"
                    }).then(async () => {
                        let res = await updateAppiontment(that.detailInfo);
                        Toast({
                            type: "success",
                            message: res.msg,
                            duration: 2000
                        });
                        that.isEdit = false;
                    }).catch(() => {
                        console.log("取消保存");
                    });
                }
            },
            async deleteAppointment() {
                const that = this;
                Dialog.confirm({title: '确认删除当前预约吗？'}).then(async () => {
                    // let res = await delAppiontment({id: that.appointmentId});
                    var detailInfoTmp = {id:that.appointmentId, status:1};
                    let res = await updateAppiontment(detailInfoTmp);
                    Toast({
                        type: "success",
                        message: res.msg,
                        duration: 1000,
                        onClose: () => {
                            // 提示关闭时，返回到我的预约界面
                            that.$router.push({path: "/appointment"});
                        }
                    });
                }).catch(() => {
                    console.log("取消删除");
                });
            },
            //----------
            // 确认预约类型
            onConfirm(value) {
                const that = this;
                that.detailInfo.type = value.value;
                that.showPicker = false;
            },
            // 确认单位性质
            onConfirm1(value) {
                const that = this;
                that.detailInfo.companyNature = value;
                that.showPicker1 = false;
            },
            // 确认文化程度
            onConfirm2(value) {
                const that = this;
                that.detailInfo.educationDegree = value;
                that.showPicker2 = false;
            },
            // 确认工种
            onConfirm3(value) {
                const that = this;
                that.detailInfo.workType = value;
                that.showPicker3 = false;
            },
            // 确认工龄
            onConfirm4(value) {
                const that = this;
                that.detailInfo.workAge = value;
                that.showPicker4 = false;
            },
            // 确认民族
            onConfirm5(value) {
                const that = this;
                that.detailInfo.nation = value;
                that.showPicker5 = false;
            },
            // 确认从业地点
            onConfirm6(value) {
                const that = this;
                that.detailInfo.workPlace = value;
                that.showPicker6 = false;
            },
        }
    };
</script>
<style lang=scss>
    .newBorder {
        border-bottom: 1px solid #f0f0f0;
    }

    .edit-cell {
        .van-field__label {
            color: #000;
            font-size: 0.32rem;
        }

        .van-icon-user-o::before {
            content: "\F0D4";
            color: #000;
            font-size: 0.32rem;
        }

        .van-icon-idcard::before {
            content: "\F073";
            color: #000;
            font-size: 0.32rem;
        }

        .van-icon-phone-o::before {
            content: "\F09A";
            color: #000;
            font-size: 0.32rem;
        }
    }

    .van-field--disabled .van-field__label {
        color: grey;
        font-size: 0.32rem;
    }

    .van-icon-user-o::before {
        content: "\F0D4";
        color: grey;
        font-size: 0.32rem;
    }

    .van-icon-idcard::before {
        content: "\F073";
        color: grey;
        font-size: 0.32rem;
    }

    .van-icon-phone-o::before {
        content: "\F09A";
        color: grey;
        font-size: 0.32rem;
    }

    .van-field__control:disabled {
        color: grey;
        -webkit-text-fill-color: grey;
    }

    .display1 {
        display:none;
    }
</style>
